<template>
  <div class="header-box">
    <div class="nav mobile-nav">
      <div class="meau-box">
        <div class="iconfont icon-ego-menu" @click="meauSwitch"></div>
        <div class="meau-list" v-show="meauShow">
          <div
            class="meau-item"
            v-for="(item, index) of navList"
            :key="index"
            @click="navigatorTo"
            :data-url="item.url"
          >
            {{ item.name }}
          </div>
        </div>
      </div>

      <div class="logo-box">
        <img
          class="logo"
          @click="navigatorTo"
          data-url="/HomePage"
          src="../assets/logo.png"
          alt=""
        />
      </div>

      <div class="nav-list">
        <div class="nav-item" v-for="(item, index) of navList" :key="index">
          <div class="nav-item-name" @click="navigatorTo" :data-url="item.url">
            {{ item.name }}
          </div>
        </div>
      </div>

      <div class="search-box">
        <div class="iconfont icon-sousuo mean-sousuo"></div>
        <input type="text" class="input-sousuo" placeholder="输入查询内容" />
      </div>
      <!-- <div class="login-box" @click="navigatorTo" data-url="/Login">Login</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "myHeader",
  data() {
    return {
      meauShow: false,
      navList: [
        // { name: '首页', ename: 'Home', url: '/HomePage' },
        { name: "关于我们", ename: "About Us", url: "/HomePage" },
        // { name: '新闻中心', ename: 'About Us', url: '/HomePage' },
        { name: "品牌文化", ename: "About Us", url: "/Culture" },
        // { name: "商务合作", ename: "About Us", url: "/HomePage" },
        { name: "产品介绍", ename: "ProductList", url: "/ProductList" },
        { name: "加入我们", ename: "About Us", url: "/JoinUs" },
        { name: "联系我们", ename: "Contact Us", url: "/ContactUs" },
        // { name: '大陆分销', ename: 'Distribution', url: '/Distribution' },
      ],
    };
  },

  methods: {
    meauSwitch() {
      this.meauShow = !this.meauShow;

      this.$emit("data-meau", this.meauShow);
    },

    navigatorTo(e) {
      this.$router.push(e.target.dataset.url);
    },
  },
};
</script>

<style lang="less" scoped>
.header-box {
  background-color: white !important;
}
.header {
  background-color: white;
  margin: 0 10vw;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e9e9e9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .header-right {
    display: flex;

    .icon-dianhua {
      font-size: 16px;
      margin-right: 16px;
      font-weight: 700;
    }

    .callUs {
      margin-right: 10px;
    }
  }
}

.nav {
  padding: 0 10vw;
  height: 90px;
  display: flex;
  justify-content: space-between;
  color: #333;

  .meau-box {
    display: none;
  }

  .icon-ego-menu {
    line-height: 90px;
    width: 50px;
  }

  .meau-list {
    z-index: 9999;
    position: absolute;
    left: 0;
    width: 100%;
    background-color: #efefef;

    .meau-item {
      line-height: 40px;
      padding: 0 20px;
    }
  }

  .login-box {
    line-height: 90px;
    font-size: 18px;
    font-weight: 700;
  }

  .logo-box {
    .logo {
      height: 90px;
    }
  }

  .nav-list {
    display: flex;
    width: 50vw;
    font-size: 18px;

    .nav-item {
      padding: 26px 10px;
      font-weight: 700;
      line-height: 22px;
      text-align: center;
      display: flex;
      align-items: center;
      /* 垂直居中 */
    }

    .nav-item-ename {
      font-size: 13px;
      font-weight: 500;
    }

    .nav-item:hover {
      cursor: pointer;
    }
  }

  .search-box {
    .mean-sousuo {
      padding: 0 20px;
      line-height: 90px;
      font-size: 24px;
      display: none;
    }

    .input-sousuo {
      height: 35px;
      margin-top: 30px;
      width: 200px;
      padding: 0 10px;
      border: 0;
      background-color: #eee;
      border-radius: 10px;
    }

    .input-sousuo:focus {
      outline: none;
      border: 1px solid #999;
    }
  }
}

@media (max-width: 768px) {
  .header-left {
    font-size: 12px !important;
  }

  .phone {
    display: none !important;
  }

  .header {
    padding: 0 20px;
  }

  .nav .mobile-nav {
    padding: 0 20px;
    display: flex;
    // width: 100vw;
  }

  .nav-list {
    display: none !important;
  }

  .input-sousuo {
    display: none !important;
  }

  .mean-sousuo {
    display: block !important;
  }

  .meau-box {
    display: block !important;
  }
}
</style>
